import { render, staticRenderFns } from "./Flag.vue?vue&type=template&id=8bb3fe7e&scoped=true&"
import script from "./Flag.vue?vue&type=script&lang=js&"
export * from "./Flag.vue?vue&type=script&lang=js&"
import style0 from "country-flag-icons/3x2/flags.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./Flag.vue?vue&type=style&index=1&id=8bb3fe7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb3fe7e",
  null
  
)

export default component.exports